import React from 'react';

/**
 * Visual badge for product stock status.
 * Props:
 *   - status: 'low_stock' | 'out_of_stock' (other values render nothing)
 *   - count:  number (only used for low_stock, optional)
 *   - note:   optional restock note (e.g. "Restock coming soon")
 *   - size:   'sm' | 'md' (default 'sm')
 */
const StockBadge = ({ status, count, note, size = 'sm' }) => {
  if (status !== 'low_stock' && status !== 'out_of_stock') return null;

  const isOOS = status === 'out_of_stock';
  const label = isOOS
    ? 'Out of Stock'
    : (count ? `Only ${count} left` : 'Low Stock');

  const baseStyle = isOOS
    ? {
        backgroundColor: 'rgba(220, 38, 38, 0.15)',
        color: '#FCA5A5',
        border: '1px solid rgba(220, 38, 38, 0.5)',
      }
    : {
        backgroundColor: 'rgba(245, 158, 11, 0.12)',
        color: '#FCD34D',
        border: '1px solid rgba(245, 158, 11, 0.45)',
      };

  const sizeClasses =
    size === 'md'
      ? 'text-xs px-2.5 py-1'
      : 'text-[10px] px-2 py-0.5';

  return (
    <span
      data-testid={`stock-badge-${status}`}
      className={`inline-flex flex-col items-start font-bold uppercase tracking-wider rounded ${sizeClasses}`}
      style={baseStyle}
    >
      <span className="inline-flex items-center gap-1">
        {!isOOS && (
          <span
            className="inline-block w-1.5 h-1.5 rounded-full animate-pulse"
            style={{ backgroundColor: '#FCD34D' }}
          />
        )}
        {label}
      </span>
      {note && (
        <span
          className="text-[9px] font-semibold normal-case tracking-normal mt-0.5"
          style={{ opacity: 0.9 }}
        >
          {note}
        </span>
      )}
    </span>
  );
};

export default StockBadge;
